import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Overlay } from '@angular/cdk/overlay';
import { BehaviorSubject, Subject } from 'rxjs';
import { SidePanelComponent } from './side-panel.component';

@Injectable()
export class SidePanelService {
    saveClicked = new Subject<any>();
    closeClicked = new Subject<any>();
    cancelClicked = new Subject<any>();
    private updateData = new BehaviorSubject<any>(null);
    updateData$ = this.updateData.asObservable();

    constructor(private sidePanel: MatDialog, private overlay: Overlay) {}

    updateDialogData(data: any): void {
        this.updateData.next({ ...data, ...{ sidePanelService: this } });
    }

    getDialogData(): any {
        return this.updateData.getValue();
    }

    open(data: any): any {
        this.updateData.next({ ...data, ...{ sidePanelService: this } });

        const ref = this.sidePanel.open(SidePanelComponent, {
            data: { ...data, ...{ sidePanelService: this } },
            maxWidth: '792px',
            panelClass: 'side-panel-dialog',
            backdropClass: 'side-panel-backdrop',
            scrollStrategy: this.overlay.scrollStrategies.noop(),
        });

        ref.backdropClick().subscribe(() => {
            if (!ref.disableClose) {
                this.closeClicked.next(data);
                this.updateData.next(null);
            }
        });
    }

    closeAll() {
        this.sidePanel.closeAll();
    }
}
